import { TBody } from '../../../components/common/table/TBody/TBody';
import { Table } from '../../../components/common/table/Table/Table';
import { MessageListHeader } from './listHeader/MessageListRow';
import { MessageListRow } from './listRow/MessageListRow';
import './MessageList.scss';

export interface MessageListProps {
  messageList: any;
}

export function MessageList({ messageList }: MessageListProps) {
  return (
    <div className="message-list">
      {messageList ? (
        <Table>
          <MessageListHeader />
          <TBody className="message-list-table-body">
            {messageList.messages.map((listItem: any, index: any) => (
              <MessageListRow
                index={index}
                timestamp={listItem?.timestamp}
                message={listItem?.message}
                tag={listItem?.tag}
                level={listItem?.level}
                key={`event-row-${index}`}
              />
            ))}
          </TBody>
        </Table>
      ) : (
        <>Select an event to display it's messages</>
      )}
    </div>
  );
}
